static function toJSON() {
    // Only serialize the following to the browser if we are a top level component.
    return {
        type: this.type,
        noHover: this.noHover,
        overlayId: this.overlayId
    }
}

$ input.toJSON = toJSON;

<span
    key="container"
    onExpander-expand("handleExpand")
    onExpander-collapse("handleCollapse")
    overlay-style=input.overlayStyle>
    <${input.renderBody}/>
</span>
